export const modbusObjectTypes: Record<number, string> = {
  0: "Coil (0x)",
  1: "Discrete Input (1x)",
  3: "Input Register (3x)",
  2: "Holding Register (4x)",
};

export const modbusValueTypes: Record<number, string> = {
  0: "BOOL",
  1: "INT16",
  2: "INT16 Unsigned",
  3: "INT32",
  4: "INT32 Unsigned",
  5: "FLOAT32",
  6: "FLOAT32 Unsigned",
};

export const modbusTemplateCategoryTypeNames: Record<number, string> = {
  0: "General",
  1: "HVAC",
  2: "Energy Monitor",
  3: "Electrical",
  4: "Environmental",
  5: "Lighting",
  6: "Custom",
};

/** Register-type code -> wire name used in telemetry keys ("hreg:35"). */
export const MODBUS_REGISTER_WIRE_NAMES: Record<number, string> = {
  0: "coil",
  1: "input",
  2: "hreg",
  3: "ireg",
};
